/* eslint-disable jsx-a11y/anchor-is-valid */
import './index.less';
import { SearchOutlined } from '@ant-design/icons';
import { Input, Button, Space, Table, Tag, Pagination, Spin, Modal, message } from 'antd';
import EmptyIcon from '@/assets/empty.png'; // 无数据状态的背景图
import { EmptyFileColor } from 'patternx-svg';
import { useState, useRef, useEffect } from 'react';
// 添加公司按钮弹窗组件
import AddCompony from './addUser';
// 导入接口
import * as api from '@/services/users';
import PtxEmpty from '@/components/ptx-empty';

const ComponyList = () => {
  useEffect(() => {
    // 页面初始化
    getUsers();
  }, []);

  // 搜索用户
  const inputValue = useRef();
  const onSearchChange = (e: any) => {
    inputValue.current = e.target.value;
    if (e.target.value === '') {
      console.log('全部删除', inputValue.current);
      getUsers(); // 搜索框内容全部删除时重新获取列表
    }
  };
  const searchUsers = async (value: any) => {
    setTableLoad(true);
    console.log('搜索用户', value);
    const res = await api.getUserListApi({
      // pageIndex: page,
      // pageSize: size,
      queryName: value,
    });
    console.log(res, '用户搜索');
    setTableLoad(false);
    if (res?.success && res.code === 200) {
      if (res?.data?.total > 0) {
        let resArray: any = [];
        res.data.records.map((item: any, index: any) => {
          item.index = index + 1;
          resArray.push(item);
        });
        console.log('resArray', resArray);
        setPage(res.data.current);
        setData(resArray);
        setTotal(res?.data?.total);
      } else if (res?.data?.total === 0) {
        // getUsers(); // 找不到用户时初始化表格
        message.error('未能找到相关用户');
        setPage(1);
        setData([]);
        setTotal(0);
      }
    } else {
      message.error('搜索用户错误');
      setData([]);
    }
  };

  // 表格参数
  // 表格表头-纵向数据设置
  const columns: any = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 80,
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      // render: (_: any, record: any) => {
      //   let components = _.split(inputValue.current);
      //   const nameArray = [components.shift(), components.join('')];
      //   const searchName = inputValue.current === '' && nameArray[1] !== '';
      //   console.log('姓名', nameArray);

      //   return searchName ? (
      //     <Space>
      //       <div>{record.name}</div>
      //     </Space>
      //   ) : (
      //     <Space>
      //       <div>
      //         {nameArray[0]}
      //         <span
      //           style={{
      //             color: '#5F4DFF',
      //             backgroundColor: '#f4f0ff',
      //             height: '22px',
      //             lineHeight: '22px',
      //           }}
      //         >
      //           {inputValue.current}
      //         </span>
      //         {nameArray[1]}
      //       </div>
      //     </Space>
      //   );
      // },
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
      // render: (_: any, record: any) => {
      //   const searchPhone = inputValue.current === _;
      //   console.log('手机号', record.phone, searchPhone);

      //   return !searchPhone ? (
      //     <Space>
      //       <div>{record.phone}</div>
      //     </Space>
      //   ) : (
      //     <Space>
      //       <div
      //         style={{
      //           color: '#5F4DFF',
      //           backgroundColor: '#f4f0ff',
      //           height: '22px',
      //           lineHeight: '22px',
      //         }}
      //       >
      //         {record.phone}
      //       </div>
      //     </Space>
      //   );
      // },
    },
    {
      title: '操作',
      key: 'action',
      width: 120,
      render: (_: any, record: any) => {
        console.log(record, _, 'render');
        const ableUser = !record.disable;
        return ableUser ? (
          <Space size="middle">
            <a
              onClick={(e) => {
                console.log('编辑用户', record);
                setUserInfo(record); // 向组件内传递用户信息
                setOpenAddCompony(true);
                setAddTitle('编辑用户');
              }}
            >
              编辑
            </a>
            <a style={{ color: '#F04438' }} onClick={() => userDisabled(record)}>
              停用
            </a>
          </Space>
        ) : (
          <Space size="middle">
            <a
              onClick={(e) => {
                console.log('编辑用户', record);
                setUserInfo(record); // 向组件内传递用户信息
                setOpenAddCompony(true);
                setAddTitle('编辑用户');
              }}
            >
              编辑
            </a>
            <a onClick={() => userAbled(record)}>启用</a>
          </Space>
        );
      },
    },
  ];

  // 设置弹窗名字
  const [addTitle, setAddTitle] = useState('');

  // 启用用户
  const userAbled = async (record: any) => {
    const res = await api.enableUserApi(record.userId);
    console.log('启用用户', res);
    if (res.code === 200 && res.success) {
      record.disable = !record.disable;
      getUsers();
      message.success('启用成功！');
    }
  };

  // 停用用户
  const userDisabled = async (record: any) => {
    const res = await api.disableUserApi(record.userId);
    console.log('停用用户', res);
    if (res.code === 200 && res.success) {
      record.disable = !record.disable;
      message.success('停用成功！');
    }
    getUsers();
  };

  // 表格每行横向数据设置
  const [data, setData] = useState([]);

  // 表格加载
  const [tableLoad, setTableLoad] = useState(true);

  // 表格初始化
  const getUsers = async () => {
    setTableLoad(true);
    const res = await api.getUserListApi({
      pageIndex: page,
      pageSize: size,
      queryName: inputValue.current,
    });

    console.log(res, '用户列表初始化');
    // api.debounce(setTableLoad(false),500)
    setTableLoad(false);
    if (res?.success && res.code === 200) {
      const tableData = res?.data?.records.map((item: any, index: number) => {
        item.index = index + 1;
      });
      // setData(res?.data?.records);
      // setTotal(res?.data?.total);
      if (res.data.records.length === 0) {
        message.error('未能找到相关用户');
      } else {
        setPage(res.data.current);
        setData(res?.data?.records);
        setTotal(res?.data?.total);
      }
    } else {
      message.error('获取用户列表错误');
      setData([]);
    }
  };
  const [page, setPage] = useState<number>(1); // 当前页码
  const [size, setSize] = useState<number>(10); // 每页显示数据数量
  const [total, setTotal] = useState<number>(0); // 总共数据量

  // 添加用户弹窗
  // 打开添加用户
  const [openAddCompony, setOpenAddCompony] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const handleOk = async () => {
    // 弹窗内确定
    if (addTitle === '添加用户') {
      console.log('弹窗内确定', addTitle);
      const res = await api.createUserApi({ ...userInfo });
      console.log('添加用户', res);
      if (res.code === 200 && res.success) {
        message.success('添加用户成功！');
        getUsers();
        setOpenAddCompony(false);
      }
    } else if (addTitle === '编辑用户') {
      console.log('编辑用户', userInfo);
      const res = await api.updateUserInfoApi({
        ...userInfo,
        disable: undefined,
        index: undefined,
      });
      console.log('编辑用户', res);
      if (res.code === 200 && res.success) {
        message.success('编辑用户成功！');
        getUsers();
        setOpenAddCompony(false);
      } else {
        message.error('编辑用户失败！');
      }
    }
  };

  const handleCancel = () => {
    // 弹窗内取消
    setOpenAddCompony(false);
  };

  // 获取添加公司的公司信息
  const componyName = useRef('');
  const getAddComponyInfo = (info: any) => {
    componyName.current = info;
    console.log('componyName.current', componyName.current);
    return info;
  };
  useEffect(() => {
    console.log(componyName.current); // 获取到公司名称
  }, [componyName.current]);
  useEffect(() => {
    // 翻页或者切换每页数量
    getUsers();
  }, [page, size]);

  return (
    <>
      <div className="wrap">
        {data.length > 0 || (data.length == 0 && inputValue.current !== undefined) ? (
          <div className="headerBar">
            <Input
              style={{ width: 350 }}
              prefix={<SearchOutlined />}
              allowClear
              onChange={onSearchChange}
              onPressEnter={() => searchUsers(inputValue.current)}
              placeholder="搜索用户姓名或手机号"
            />
            <div>
              <Button
                type="primary"
                ghost={false}
                onClick={() => {
                  setAddTitle('添加用户');
                  setOpenAddCompony(true);
                }}
                style={{ marginRight: 16 }}
              >
                添加用户
              </Button>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="memberTable">
          <Spin spinning={tableLoad}>
            {data.length > 0 ? (
              <Table
                rowKey="usersId"
                columns={columns}
                dataSource={data}
                pagination={{
                  size: 'small',
                  showTotal: (total, range) => {
                    return `${range[0]}-${range[1]}条，共${total}条`;
                  },
                  showTitle: true,
                  showQuickJumper: false,
                  showSizeChanger: true,
                  total: total, // 分页总数
                  pageSize: size, // 每页数量
                  current: page, // 当前页数
                  onChange: (p, s) => {
                    console.log('翻页', { p, s });
                    setPage(p);
                    setSize(s as number);
                  },
                }}
                scroll={{ y: 'calc(100vh - 368px)' }}
              />
            ) : (
              <div className="emptyInfo">
                {/* <IconFont className={styles.emptyImage} type="icon-kong" /> */}
                {/* <img src={EmptyIcon} className="emptyImage" /> */}
                {/* <EmptyFileColor /> */}
                {/* <div className="emptyBody">没有用户</div> */}
                <PtxEmpty
                  isEmpty={!inputValue.current}
                  describe="没有用户"
                  icon={<EmptyFileColor />}
                  btnRender={() => {
                    if (inputValue.current) {
                      return undefined;
                    }
                    return (
                      <Button type="primary" className="emptyFooter">
                        <span
                          className="link"
                          onClick={() => {
                            setAddTitle('添加用户');
                            setOpenAddCompony(true);
                          }}
                          style={{ margin: '0 4px' }}
                        >
                          添加用户
                        </span>
                      </Button>
                    );
                  }}
                />
              </div>
            )}
          </Spin>
        </div>
      </div>
      {/* 添加用户 */}
      {openAddCompony && (
        <AddCompony
          handleOK={handleOk}
          handleCancel={handleCancel}
          showModal={openAddCompony}
          getAddComponyInfo={getAddComponyInfo}
          setUserInfo={setUserInfo}
          userInfo={userInfo}
          addTitle={addTitle}
        />
      )}
    </>
  );
};

export default ComponyList;
